<net-address-form mode="dialog" [loading]="loading" [columnCount]="2" [address]="address" [customer]="customer"
  (save)="onSave($event)" (isFormChange)="onFormChanged($event)" [formChanged]="formChanged"
  [closeAddressFormDialog]="closeAddressFormDialog.bind(this)"></net-address-form>